<template>
  <div
    class="section section-signup"
    style="background-image: url('img/road.jpg'); background-size: cover; background-position: top center; min-height: 800px;"
  >
    <div class="container">
      <div class="row">
        <div class="col-md-10 offset-md-1" align-self="center">
          <carousel navigationenabled="true" :scrollPerPage="true" :perPageCustom="[[480, 2], [1280, 3]]">
            <template v-for="x in items">
              <slide :key="x.title" style="width: 300px; max-width: 100%;">
              <div class="col-md-10">
                <servicescard :icon="x.icon" :title="x.title"></servicescard>
              </div>
            </slide>
            </template>
          </carousel>
        </div>
      </div>
      <div class="col text-center">
        <router-link
          to="/about"
          class="btn btn-primary btn-lg btn-round"
          role="button"
        >
          About Us
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, FormGroupInput, Button } from '@/components';
import servicescard from '@/components/Cards/servicescard';
import { Carousel, Slide } from 'vue-carousel';

export default {
  components: {
    Carousel,
    Slide,
    Card,
    servicescard,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data () {
    return {
      items: [
        {'title': 'Prompt', 'icon': 'prompt.png'},
        {'title': 'Secure', 'icon': 'secure.png'},
        {'title': 'Reliable', 'icon': 'reliable.png'},
        {'title': 'Convenient', 'icon': 'convenient.png'},
        {'title': 'Affordable', 'icon': 'affordable.png'},
        {'title': 'Receptive', 'icon': 'receptive.png'},
      ]
    }
  }
};
</script >
<style>

</style>
